import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from '../../../UI/Button/Button';
import {getSettings} from '../../selectors/selectors';
import CheckoutOverlay from '../CheckoutOverlay/CheckoutOverlay';
import Translation from '../../lang/Translation';
import fastTrackLogo from '../ui/svg/fastTrackLogo.svg';
import useStyles from './FastTrackInfo.styles';

export function FastTrackInfo(props) {
  const classes = useStyles();
  
  const getLinkProps = href => ({
    rel: 'external', target: '_blank', href,
  });
  
  return (
    <CheckoutOverlay popup>
      <div className={classes.title} data-test="FastTrackInfo__title">
        <img
          className={classes.logo}
          data-test="FastTrackInfo__modalLogo"
          src={fastTrackLogo}
          alt="Fast Track Logo"
          title={Translation.getText('fastDelivery.logo')}
        />
        <Translation>deliveryOptions.fastDelivery.text</Translation>
      </div>
      <div className={classes.container} data-test="FastTrackInfo__container">
        <div className={classes.text} data-test="FastTrackInfo__text">
          <Translation tagProps={[getLinkProps(props.termsAndConditions)]}>
            fastDelivery.terms.and.conditions
          </Translation>
        </div>
        <div className={classes.button} data-test="FastTrackInfo__infoButton">
          <Button
            id="FastTrackInfo__infoButton"
            primary
            href={props.fastTrackInfo}
          >
            <Translation>link.more.info</Translation>
          </Button>
        </div>
      </div>
    </CheckoutOverlay>
  );
}

FastTrackInfo.propTypes = {
  termsAndConditions: PropTypes.string.isRequired,
  fastTrackInfo: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const {unsecureHomePageUrl} = state.start.siteDataV2;
  const settings = getSettings(state);
  return {
    termsAndConditions: settings.terms_link?.startsWith('http') ? settings.terms_link : `${unsecureHomePageUrl}${settings.terms_link}`,
    fastTrackInfo: `${unsecureHomePageUrl}delivery.fasttrack`,
  };
};

export default connect(mapStateToProps)(FastTrackInfo);
